module.exports = __webpack_public_path__ + "static/fonts/Ping-Fang-SC-Regular.d979e7e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/fonts/Ping-Fang-SC-Regular.ttf
// module id = 8coM
// module chunks = 1